import React, { useEffect, useState } from "react";
import { Oval } from "../../assets/imagesPath";
import { useForm } from "react-hook-form";
import Dropdown from "../../assets/icons/Dropdown";
import { useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessForm } from "../../redux/AuthSlice";
import Select from "react-select";
import { options1, options2, options3 } from "../../data/States";

const ClientScreening = () => {

  const [description, setDescription] = useState("");
  const [whatYouDo, setWhatYouDo] = useState("");
  const [challanges, setChallanges] = useState("");
  const [painPoint, setPainPoint] = useState("");
  const [otherPainPoint, setOtherPainPoint] = useState("");
  const [otherChallenge, setOtherChallenge] = useState("");
  const [enableTabs, setEnableTabs] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((data) => data?.auth);
  const formData = auth?.businessDetailForm;


  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "white",
      border: "1px solid #ddd",
      borderRadius: "10px",
      padding: "5px",
      fontSize: "1.2rem",
      cursor: "pointer",

    }),
    menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0, }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#173363",
      borderRadius: "4px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "white" : "#173363",
      color: state.isFocused ? "#173363" : "white",
      cursor: "pointer",
      fontSize: "1.2rem",
      // padding: "8px",
      borderRadius: "4px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    singleValue: (base) => ({
      ...base,
      color: "black",
      fontSize: "1.6rem",
    }),
  };


  const {
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = () => {

    const data = {
      clientScreening: {
        businessDescription: description,
        businessType: whatYouDo,
        businessChallenges: [challanges],
        biggestPainPoint: painPoint,
        otherPainPoint: otherPainPoint,
        otherChallenge: otherChallenge
      },
    };

    dispatch(updateBusinessForm(data));
    navigate(PATHS.businessFormation);
  };

  const validationHandler = () => {
    let noError = false;

    descriptionValidationHandler();
    challangesValidationHandler();
    painPointValidationHandler();

    if (description && challanges && painPoint) {
      onSubmit();
      setEnableTabs(true);
    } else {
      return false;
    }

    return noError;
  };

  const descriptionValidationHandler = () => {
    if (!description) {
      setError("description", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("description");
    }
  };

  const challangesValidationHandler = () => {
    if (!challanges) {
      setError("challanges", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("challanges");
    }
  };

  const painPointValidationHandler = () => {
    if (!painPoint) {
      setError("painPoint", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("painPoint");
    }
  };

  useEffect(() => {
    if (formData?.clientScreening) {
      let { businessDescription, businessType, businessChallenges, biggestPainPoint, otherPainPoint, otherChallenge } = formData?.clientScreening;
      setDescription(businessDescription);
      setWhatYouDo(businessType);
      setChallanges(businessChallenges[0]);
      setPainPoint(biggestPainPoint);
      setOtherPainPoint(otherPainPoint);
      setOtherChallenge(otherChallenge);
    }
  }, [JSON.stringify(formData?.clientScreening)]);
  
  useEffect(() => {
    if (description) clearErrors("description");
    if (challanges) clearErrors("challanges");
    if (painPoint) clearErrors("painPoint");
  }, [description, challanges, painPoint, clearErrors]);

  return (
    <div className="w-full mb-16">


      <div className="mx-auto text-center mb-10 space-x-4 space-y-4 mt-40 tabsBtn">
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.basicInfo)}
        >
          Basic Infomation
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessDetails)}
        >
          Business Details
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.servicesNeeded)}
        >
          Services Needed
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#173363] text-[#FFFFFF] border border-[#8188918C]"
          onClick={() => navigate(PATHS.clientScreening)}
        >
          Client Screening Questions
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessFormation)}
          disabled={!enableTabs}
        >
          Business Formation Decision
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.additionalDetails)}
          disabled={!enableTabs}
        >
          Additional Details
        </button>
      </div>

      <div className="flex justify-center items-center p-16 pb-40 min-h-[50vh]">
        <div className="w-3/4 smallScreens:w-full bg-white mt-20 shadow-2xl rounded-xl p-10 md:p-20 relative">
          {/* <div className="text-[2.4rem] text-[#121212] text-center mb-20 font-extrabold">Client Screening Questions</div> */}
          <div className="space-y-12">
            <div className="grid grid-cols-2 gap-8 mt-10">
              <div >
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[0.8rem] mediumScreens:text-[1.2rem]">
                  Describe Your Business In A Few Sentences. What Do You Do?
                </label>
                <input
                  type="text"
                  placeholder="Enter Here"
                  className="w-full text-[1.6rem] fix_height_input p-5 mediumScreens:p-4 border-2 border-[#F5F5F2] rounded-2xl mt-1 focus:outline-none"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
                {errors.description && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.description.message}
                  </p>
                )}
              </div>

              <div >
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1.2rem]">
                  Suggested Trades
                </label>
                <div className='relative mt-4'>
                  <Select
                    options={options1}
                    value={options1?.find((option) => option.value === whatYouDo)}
                    onChange={(selectedOption) => setWhatYouDo(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                </div>
                {/* {errors.whatYouDo && (
                <p className="text-red-500 text-[1.2rem] mt-1">
                  {errors.whatYouDo.message}
                </p>
              )} */}
              </div>

              <div >
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[0.8rem] mediumScreens:text-[1.2rem]">
                  What Challenges Are You Facing In Managing Your Business?
                </label>
                <div className='relative mt-4'>
                  <Select
                    options={options2}
                    value={options2?.find((option) => option.value === challanges)}
                    onChange={(selectedOption) => setChallanges(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />
                  {/* <span className="absolute inset-y-0 right-5 flex items-center ">
                    <Dropdown />
                  </span> */}
                </div>
                {errors.challanges && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.challanges.message}
                  </p>
                )}
              </div>

              <div >
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1.2rem]">
                  What Is Your Biggest Pain Point?
                </label>
                <div className='relative mt-4'>
                  <Select
                    options={options3}
                    value={options3?.find((option) => option.value === painPoint)}
                    onChange={(selectedOption) => setPainPoint(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                </div>
                {errors.painPoint && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.painPoint.message}
                  </p>
                )}
              </div>
            </div>
            {challanges == "Other" ?
              <div className='mt-4'>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1.2rem]">
                  Tell us about the Challange you are facing?
                </label>
                <div className='relative mt-4'>
                  <input
                    type="text"
                    placeholder="Enter Here"
                    className="w-full text-[1.6rem] fix_height_input p-5 mediumScreens:p-4 border-2 border-[#F5F5F2] rounded-2xl mt-1 focus:outline-none"
                    onChange={(e) => setOtherChallenge(e.target.value)}
                    value={otherChallenge}
                  />

                </div>
                {errors.challanges && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.challanges.message}
                  </p>
                )}
              </div>
              : null}

            {painPoint == "Other" ?
              <div className='mt-4'>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1.2rem]">
                  Tell us about your PainPoint?
                </label>
                <div className='relative mt-4'>
                  <input
                    type="text"
                    placeholder="Enter Here"
                    className="w-full text-[1.6rem] fix_height_input p-5 mediumScreens:p-4 border-2 border-[#F5F5F2] rounded-2xl mt-1 focus:outline-none"
                    onChange={(e) => setOtherPainPoint(e.target.value)}
                    value={otherPainPoint}
                  />

                </div>
                {errors.painPoint && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.painPoint.message}
                  </p>
                )}
              </div>
              : null}

            <div className="text-center">
              <button
                type="button"
                className="w-2/3 text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                onClick={validationHandler}
              >
                Save
              </button>
            </div>
          </div>
          <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
            <img src={Oval} alt="oval-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientScreening;